import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

import { useActiveTabType } from '../../../store/hooks/offers';

interface IViewObserver {
  handleView: () => void;
  blockRef: RefObject<HTMLAnchorElement>;
}

export const useViewObserver = ({ handleView, blockRef }: IViewObserver) => {
  const activeTabType = useActiveTabType();
  const wasSendViewingEvent = useRef<boolean>(false);

  useEffect(() => {
    wasSendViewingEvent.current = false;
  }, [activeTabType?.type, activeTabType?.subtype]);

  useEffect(() => {
    const block = blockRef?.current;

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25,
    };

    const listener: IntersectionObserverCallback = (entries) => {
      entries.forEach((entry) => {
        if (!wasSendViewingEvent.current && entry.intersectionRatio >= 0.25) {
          handleView();

          wasSendViewingEvent.current = true;
        }
      });
    };

    const observer = new IntersectionObserver(listener, options);

    if (!block) return;

    observer.observe(block);

    return () => {
      observer.unobserve(block);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockRef, handleView]);
};
